const doc = [({"ja":({"adminComponentHotelChildrenSetting":({"hotelChildrenSettingTitle":"子供設定", "notesTitle":"注意事項", "addCategory":"区分の追加", "editCategory":"区分の編集"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;